import React, { PureComponent } from 'react';
import { encodeForURI } from 'appSrc/utils';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { UserAvatar, Icon } from 'appSrc/components/UI';
import { ProductNewRowItem } from 'appSrc/components/Product';
import style from './styles/style.module.css';

class ExpandedLACard extends PureComponent {
    convertToStandard = ( original={} ) => {
        let output = {};
        if( original.listid ) {
            //it's a list
            output = {
                author: original.author || {},
                desires: original.desires || [],
                title: original.title,
                internal_link: `/${ original.author.slug }/${ original.slug }`,
            };
        } else {
            output = {
                author: original.author || {},
                desires: original.desires || [],
                title: original.title,
                internal_link: `/app/articles/${ original.id }/${ encodeForURI(original.title) }`,
            };
        }
        return output;
    }
    render() {
        const item = this.convertToStandard( this.props.item );

        const author = item.author || {};
        const profession = ( author.profession || {} ).title;
        const desires = item.desires || [];

        return (
            <div className={ `${ style.expandedCard } ${ this.props.className }`.trim() }>
                <div className={ style.details }>
                    <div className={ style.background }>
                        <div className={ style.overlay } style={ { backgroundImage: `url(${ author.avatar })` } }></div>
                    </div>
                    <div className={ style.authorInfo }>
                        <Link to={ '/' + author.slug }>
                            <UserAvatar className={ style.avatar } src={ author.avatar } size={ null } />
                            <div className={ style.infoText }>
                                { profession &&
                                    <div className={ style.profession }>{ profession }</div>
                                }
                                <div className={ style.displayName }>{ author.displayName }</div>
                            </div>
                        </Link>
                    </div>
                    <Link to={ item.internal_link } className={ style.title }>{ item.title }</Link>
                </div>
                <div className={ style.products }>
                    { desires.slice( 0, 3 ).map( ( product ) => {
                        return ( <ProductNewRowItem product={ product } key={ 'featured-list-product-'+product.desireid } /> );
                    } ) }

                    <div className={ style.internalLink }>
                        <Link to={ item.internal_link }>
                            See the full list&emsp;
                            <Icon source='customSvg' icon='arrow-right' size={ 23 } />
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}
ExpandedLACard.propTypes = {
    item: PropTypes.object.isRequired,
};
ExpandedLACard.defaultProps = {
    className: '',
};

export default ExpandedLACard;
